import { Col, Collapse, Typography } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

const { Panel } = Collapse;

interface ImportErrorsPropsTypes {
  importErrors: any[] | undefined;
}

export default function ImportErrors(props: ImportErrorsPropsTypes): React.ReactElement {
  const { importErrors } = props;

  const { t } = useTranslation();

  const showErrorsImportProducts = () => {
    return importErrors?.map(item => {
      return (
        <div className="import-error-row" key={item?.field}>
          <span className="import-field">{item?.field}: </span>
          {item?.messages.map((item: any, index: number) => {
            return (
              <span className="import-message" key={index}>
                {item}
              </span>
            );
          })}
        </div>
      );
    });
  };

  const subtitle = () => {
    return (
      <div className="subtitles">
        <span className="subtitle">
          <div style={{ background: "#d9363e" }} className="square"></div>
          <span className="subtitle-text">{t("The line could not be imported")}</span>
        </span>
        <span className="subtitle">
          <div style={{ background: "#faad14" }} className="square"></div>
          <span className="subtitle-text">
            {t("The field in the line had an error and was ignored")}
          </span>
        </span>
      </div>
    );
  };

  return (
    <>
      {importErrors && importErrors.length > 0 && (
        <Col sm={16} xs={24} className="errors-col">
          <Typography.Title level={5}>{t("Import errors")}</Typography.Title>
          <Col xs={24} sm={24}>
            <Collapse defaultActiveKey={["1"]}>
              <Panel header={t("Errors")} key="1">
                {showErrorsImportProducts()}
              </Panel>
            </Collapse>
            {subtitle()}
          </Col>
        </Col>
      )}
    </>
  );
}
